import { useEffect } from "react";
import { Icon } from "@iconify/react";
import "./css/modal.css";

const Modal = ({ open, onClose, title, children, size = "md" }) => {
  useEffect(() => {
    const handleEsc = (e) => e.key === "Escape" && onClose();
    if (open) document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [open, onClose]);

  if (!open) return null;

  const sizeMap = {
    sm: "500px",
    md: "700px",
    lg: "900px",
    xl: "1100px",
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-card"
        style={{ maxWidth: sizeMap[size] }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header-custom">
          <h5 className="fw-semibold m-0">{title}</h5>

          <button className="modal-close-btn" onClick={onClose}>
            <Icon icon="mdi:close" width="18" />
          </button>
        </div>

        <div className="modal-body-custom">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
